/* ============================================================
   AYF Theme — vanilla JS, no framework.
   Drawer (cart, search), mega menu, FAQ, qty steppers,
   product gallery, policy gate enforcement.
   ============================================================ */

(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---- Drawer open/close ---- */
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusable = drawer.querySelector('input, button, [href]');
    if (focusable) focusable.focus();
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---- Mobile hamburger nav ---- */
  function closeMobileNav() {
    const nav = $('.site-header__nav');
    if (!nav) return;
    nav.classList.remove('is-open');
    document.body.style.overflow = '';
    const toggle = $('[data-mobile-nav-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }
  $$('[data-mobile-nav-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const nav = $('.site-header__nav');
      if (!nav) return;
      const isOpen = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  });
  // Explicit X close button inside the mobile nav overlay
  $$('[data-mobile-nav-close]').forEach(btn => btn.addEventListener('click', closeMobileNav));
  // Close mobile nav when an actual nav link is tapped (NOT a dropdown trigger button)
  document.addEventListener('click', e => {
    const link = e.target.closest('.site-header__nav a');
    if (!link) return;
    closeMobileNav();
  });
  // Escape closes the mobile nav too
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const nav = $('.site-header__nav');
    if (nav && nav.classList.contains('is-open')) closeMobileNav();
  });

  $$('[data-cart-toggle]').forEach(el => el.addEventListener('click', () => openDrawer($('[data-cart-drawer]'))));
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', () => closeDrawer($('[data-cart-drawer]'))));
  $$('[data-search-toggle]').forEach(el => el.addEventListener('click', () => openDrawer($('[data-search-drawer]'))));
  $$('[data-search-close]').forEach(el => el.addEventListener('click', () => closeDrawer($('[data-search-drawer]'))));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeDrawer($('[data-cart-drawer]'));
      closeDrawer($('[data-search-drawer]'));
    }
  });

  /* ---- Mega menu (click-to-open) ---- */
  $$('.has-dropdown .site-header__nav-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const parent = trigger.closest('.has-dropdown');
      const isOpen = parent.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  /* ---- Quantity steppers ---- */
  $$('[data-qty-change]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      if (!input) return;
      const delta = btn.dataset.qtyChange === '+' ? 1 : -1;
      const next = Math.max(parseInt(input.min || 0, 10), parseInt(input.value, 10) + delta);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---- Policy gate (cart drawer + cart page + product page) ----
     Disables the checkout button until the customer ticks the agreement. */
  function wirePolicyGate() {
    const drawer = $('[data-cart-drawer]');
    const drawerGate = drawer && drawer.querySelector('[data-policy-gate]');
    const drawerBtn = drawer && drawer.querySelector('[data-checkout-btn]');
    const drawerError = drawer && drawer.querySelector('[data-policy-gate-error]');
    if (drawerGate && drawerBtn) {
      drawerGate.addEventListener('change', () => {
        if (drawerGate.checked) {
          drawerBtn.disabled = false;
          drawerBtn.removeAttribute('aria-disabled');
          if (drawerError) drawerError.hidden = true;
        } else {
          drawerBtn.disabled = true;
          drawerBtn.setAttribute('aria-disabled', 'true');
        }
      });
      drawerBtn.addEventListener('click', e => {
        if (!drawerGate.checked) {
          e.preventDefault();
          if (drawerError) drawerError.hidden = false;
        }
      });
    }

    const pageGate = $('[data-policy-gate-page]');
    const pageBtn = $('[data-checkout-page]');
    if (pageGate && pageBtn) {
      pageGate.addEventListener('change', () => {
        pageBtn.disabled = !pageGate.checked;
      });
    }
  }
  wirePolicyGate();

  /* ---- Product page: gallery thumb click ---- */
  $$('[data-gallery-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const i = thumb.dataset.index;
      $$('[data-gallery-thumb]').forEach(t => t.classList.toggle('is-active', t === thumb));
      $$('[data-gallery-image]').forEach(img => img.classList.toggle('is-active', img.dataset.index === i));
    });
  });

  /* ---- Product page: variant resolution on option change (selector matches new ProductForm id) ---- */

  /* ---- Variant resolution ---- */
  function resolveVariant() {
    const form = document.getElementById('ProductForm');
    if (!form) return;
    const jsonEl = $('[data-product-json]');
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const selectedOptions = $$('[data-option-input]:checked', form).map(i => i.value);
    if (!selectedOptions.length) return;
    const match = product.variants.find(v =>
      v.options.every((opt, idx) => opt === selectedOptions[idx])
    );
    if (!match) return;
    const variantInput = form.querySelector('[data-variant-id]');
    if (variantInput) variantInput.value = match.id;
    const priceEl = $('[data-price]');
    if (priceEl) {
      priceEl.innerHTML = formatMoney(match.price);
      if (match.compare_at_price && match.compare_at_price > match.price) {
        priceEl.innerHTML += ` <s>${formatMoney(match.compare_at_price)}</s>`;
      }
    }
    const submitBtn = form.querySelector('[data-add-to-cart]');
    const label = form.querySelector('[data-add-label]');
    if (submitBtn && label) {
      submitBtn.disabled = !match.available;
      submitBtn.setAttribute('aria-disabled', match.available ? 'false' : 'true');
      label.textContent = match.available ? 'Add to cart' : 'Sold out';
    }
  }
  $$('[data-option-input]').forEach(i => i.addEventListener('change', resolveVariant));

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- Cart drawer: AJAX add to cart, refresh drawer ---- */
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async e => {
      // Only intercept when policy gate is satisfied (or absent).
      const inlineGate = productForm.querySelector('[data-policy-gate-inline]');
      if (inlineGate && !inlineGate.checked) return; // let HTML5 required handle it
      e.preventDefault();
      const formData = new FormData(productForm);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('add to cart failed');
        await refreshCart();
        openDrawer($('[data-cart-drawer]'));
      } catch (err) {
        console.error(err);
        productForm.submit(); // fallback to non-JS submit
      }
    });
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      $$('[data-cart-count]').forEach(el => el.textContent = data.item_count);
      $$('[data-cart-count-text]').forEach(el => el.textContent = `(${data.item_count})`);
      $$('[data-cart-subtotal]').forEach(el => el.textContent = formatMoney(data.total_price));
      // Full drawer re-render: fetch the cart drawer section markup
      const sectionRes = await fetch('/?section_id=cart-drawer-refresh');
      if (sectionRes.ok) {
        const html = await sectionRes.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newItems = tmp.querySelector('[data-cart-items]');
        const current = $('[data-cart-items]');
        if (newItems && current) current.innerHTML = newItems.innerHTML;
      }
    } catch (err) {
      console.error('cart refresh failed', err);
    }
  }
})();
